export default "__VITE_ASSET__JwGds8Ek__"